export const BASE_URL = "https://tourist-guide-api.vercel.app/api/v1";
